import { useRouter } from 'next/router';
import { getRegionFromRouteParam } from 'utils/market';
import { getRegion } from 'utils/i18n/get-region';

export const useRegion = (): ReturnType<typeof getRegionFromRouteParam> => {
  const { query } = useRouter();

  if (query?.region) {
    return getRegionFromRouteParam(query.region);
  }

  return getRegion(typeof window === 'undefined' ? undefined : window.location.hostname);
};
